import { render, staticRenderFns } from "./EquipmentDetailSideBar.vue?vue&type=template&id=56864155&scoped=true&"
import script from "./EquipmentDetailSideBar.vue?vue&type=script&lang=js&"
export * from "./EquipmentDetailSideBar.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentDetailSideBar.vue?vue&type=style&index=0&id=56864155&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56864155",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VDivider,VNavigationDrawer})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56864155')) {
      api.createRecord('56864155', component.options)
    } else {
      api.reload('56864155', component.options)
    }
    module.hot.accept("./EquipmentDetailSideBar.vue?vue&type=template&id=56864155&scoped=true&", function () {
      api.rerender('56864155', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/components/EquipmentDetailSideBar.vue"
export default component.exports